import styled from 'styled-components';
import { layout } from 'src/components/base';
import { DEFAULT_STORE_LOGO_MAX_WIDTH } from 'src/components/store-logo';

const EXTRA_SMALL_DISPLAY_WIDTH = '280px';

export const StoreInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  gap: ${layout.measurements.spacing025};
  width: 104px;
  padding: ${layout.measurements.spacing050};
  margin: 0;

  /* Small mobile resolutions, e.g. Galaxy Fold */
  @media screen and (max-width: ${EXTRA_SMALL_DISPLAY_WIDTH}) {
    width: calc(
      ${DEFAULT_STORE_LOGO_MAX_WIDTH}px + ${layout.measurements.spacing050}
    );
  }
`;

export const StoreInfoTitle = styled.span`
  /* Visually hidden since this text is primarily for Google */
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

export const InfoGroup = styled.div`
  display: flex;
  gap: ${layout.measurements.spacing025};
`;
